import { render, staticRenderFns } from "./qttpffx.vue?vue&type=template&id=9bf42f74&"
import script from "./qttpffx.vue?vue&type=script&lang=js&"
export * from "./qttpffx.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports